export const enum CategoryType {
  /** 大分類 */
  LARGE = 1,
  /** 中分類 */
  MIDDLE,
  /** 子分類 */
  SMALL,
}
